module.exports = __REACT_WEB_CONFIG__;
